import React from 'react'
import PropTypes from 'prop-types'

import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'

import TopicInfoSkeleton from './TopicInfoSkeleton'

const TopicInfo = ({ name, description, coverImageUrl, children }) => (
  <TopicInfoSkeleton
    nameSection={name}
    descriptionSection={description}
    imageSection={
      coverImageUrl && (
        <AspectRatioImage
          imgUrl={coverImageUrl}
          altText={name}
          aspectRatio="16:9"
        />
      )
    }
  >
    {children}
  </TopicInfoSkeleton>
)

TopicInfo.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  coverImageUrl: PropTypes.string,
  children: PropTypes.any,
}

export default TopicInfo
